<script lang="ts">
	import type { Snippet } from "svelte";
	import { cn } from "#lib/web-ui/ui/utils.js";
	import { Section } from "#lib/web-ui/primitives/index.js";
	import type { FooterRowProps } from "./footer.types";

	type Props = FooterRowProps & {
		children: Snippet;
	};

	let { class: className, children }: Props = $props();
</script>

<Section
	class={cn(
		"bg-transparent py-8 md:py-12 [&>div]:flex [&>div]:flex-col [&>div]:md:flex-row",
		className
	)}
>
	{@render children()}
</Section>
